<template>
  <div class="frimwareTask-version-box">
    <div class="content-box">
      <h1 class="item-title">{{ $t('asm_offline_service_command.she_bei_xin_xi') }}</h1>
      <div class="item-title-info">
        <el-row>
          <el-col :span="8">
            <span class="label">{{ $t('asm_offline_service_command.chan_pin_xing_hao') }}</span>
            <span class="value">{{ detail.productCode }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('asm_offline_service_command.ji_shen_hao') }}</span>
            <span class="value">{{ detail.bodyNum }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">Modem SN:</span>
            <span class="value">{{ detail.modemSn }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('asm_offline_service_command.shou_hou_gong_si') }}</span>
            <span class="value">{{ detail.afterServiceName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('asm_offline_service_command.dai_li_gong_si') }}</span>
            <span class="value">{{ detail.agentCoName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('asm_offline_service_command.zu_lin_fang') }}</span>
            <span class="value">{{ detail.customerName }}</span>
          </el-col>
        </el-row>
      </div>
      <h1 class="item-title">{{ $t('asm_offline_service_command.xzxghdbj') }}</h1>
      <custom-select
        v-model="componentCode"
        :data="partList"
        :auto="false"
        :props="{ label: 'componentName', value: 'componentCode' }"
        :placeholder="i18n.com_please_select"
        width="280px"
        style="margin-bottom: 14px; vertical-align: top"
        @change="selectComponentCode"
      ></custom-select>
      <h1 class="item-title">{{ $t('asm_offline_service_command.xzxxfdpz') }}</h1>
      <!--
        配置名称 topicName
        操作
        /productStructure/topicList
        更换零件时系统主动下发Topic集合
      -->
      <div class="table-bd">
        <custom-table
          ref="table"
          index
          :data="commandList"
          height="100%"
          :loading="isLoading"
          :column="tableColumn"
          :slots="['action']"
        >
          <template v-slot:action="scope">
            <el-button
              type="text"
              size="mini"
              @click="onSetParams(scope.row)"
            >
              {{ $t('asm_offline_service_command.ckszcs') }}
            </el-button>

          </template>
        </custom-table>
      </div>
    </div>
    <div class="btn-group">
      <el-button size="small" @click="onCancel">{{ i18n.com_cancel }}</el-button>
      <el-button  @click="previous">
       {{ $t('asm_offline_service_command.shang_yi_bu') }}
      </el-button>
      <el-button type="primary" @click="onComplete">
        {{ $t('Common.com_finish') }}
      </el-button>
    </div>

  <!-- 表单录入 -->
    <offline-service-param-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
    >
    </offline-service-param-dialog>

    <!-- 数据存档 -->
    <offlineService-command-modifyBill-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
    >
    </offlineService-command-modifyBill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import offlineServiceParamDialog from './offline_service_param_dialog.vue';
import offlineServiceCommandModifyBillDialog from './offline_service_command_modifyBill_dialog.vue';

export default {
  mixins: [languageInjectMixins],
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    },
    value: {
      type: Boolean,
      default: false
    },
    data: [String, Object, Array],
    serviceModemId: [String, Number],
    serviceRecordId: [String, Number]
  },
  components: {
    offlineServiceParamDialog,
    offlineServiceCommandModifyBillDialog
  },

  data() {
    return {
      detail: {},
      partList: [
        {
          componentCode: 'vcu',
          componentName: 'VCU',
        },
        {
          componentCode: 'modem',
          componentName: this.$t('asm_offline_service_command.tong_xun_ban'),
        },
      ],
      componentCode: '',
      componentName: '',
      commandList: [],
      tableCode: 'offline_service_topic',
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},

    };
  },
  mounted() {
    this.getTableColumn();
    this.getDetailInfo();


  },
  methods: {
    onCancel() {
      this.jump('/offline/service');
    },
    // 获取变更详情
    getDetailInfo: function () {
      this.$getJSON(`${apis.serviceModemRecordInfo}/${this.serviceRecordId}`).then((res) => {
        this.detail = res.data || {};
      });
    },
    // 选择部件
    selectComponentCode(item) {
      this.componentName = item.componentName;
      // 每次切换都需要调用更新
      this.onModemRecordUpdate();
      // 获取下拉
      this.getCommandList();
    },
    // 获取配置表格数据
    getCommandList() {
      this.$getJSON(apis.componentTopicList, {
        productCode: this.detail.productCode,
        bodyNum: this.detail.bodyNum,
        componentCode: this.componentCode
      }).then((res) => {
        this.commandList = res.data || [];
      });
    },
    // 更新服务信息 每次切换部件都要触发刷新
    onModemRecordUpdate() {
      this.$postJSON(apis.serviceModemRecordUpdate, {
        componentCode: this.componentCode,
        componentName: this.componentName,
        serviceRecordId: this.serviceRecordId
      }).then(() => {});
    },
    // 查看修改设置
    onSetParams({ commandMode, topicPublishId }) {
      // 1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择
      if (`${commandMode}` === '4') {
        this.dialogModel.title = this.componentName;
        this.dialogModel.type = 'edit';
        this.dialogModel.data = {
          serviceRecordId: this.serviceRecordId,
          modemSn: this.detail.modemSn,
          topicPublishId: topicPublishId,
        };
        this.dialogVisible = true;
      } else {
        this.dialogModel1.title = this.componentName;
        this.dialogModel1.type = 'edit';
        this.dialogModel1.data = {
          serviceRecordId: this.serviceRecordId,
          modemSn: this.detail.modemSn,
          topicPublishId: topicPublishId,
        };
        this.dialogVisible1 = true;
      }

    },

    // 上一步
    previous: function () {
      this.$emit('previous');
    },
    // 完成
    onComplete: function () {
      this.jump('/offline/service');
    }
  }
};
</script>

<style lang="scss">
.frimwareTask-version-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;

  box-sizing: border-box;
  .content-box {
    flex: 1;
    overflow-y: auto;
    display: flex;
    padding: 24px 24px 0 24px;
    flex-direction: column;
  }
  .params-bd {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
  }
  .btn-group {
    border-top: 1px solid #eef2f8;
    padding: 16px 0 16px 24px;
    height: 60px;
    z-index: 1;
    -webkit-box-flex: 0;
    flex: 0 0 60px;
  }

  .firmware-code {
    text-decoration: underline;
  }
}
</style>
